const toHex = (amount) => {
  const hex = amount.toString(16);
  return "0x".concat(hex);
};
export {
  toHex
};
//# sourceMappingURL=toHex.js.map